import React from 'react'
import useSWR from "swr";
import { useParams } from "react-router-dom";
const Lifetime = () => {
  let params = useParams();
  const { data, error } = useSWR(
    process.env.REACT_APP_DEF_URL + "product.php?product_link=" + params.productName
  );
  if (error) return <div>failed to load</div>
  if (!data) return <div>loading...</div>
  return (
    <div dangerouslySetInnerHTML={{__html:data.product_lifetime}}></div>
  )
}

export default Lifetime